export default __webpack_public_path__ + "static/media/confirmation4.6488c705.jpg";